import React, { useEffect, useRef, useState } from 'react';
import { mfaStyles as styles } from './mfaStyles';
import { useMfaDialog } from './useMfaDialog';
import MfaSecuritySection from './MfaSecuritySection';
import MfaRecoveryForm from './MfaRecoveryForm';
import EmailChangeSection from './EmailChangeSection';

export default function MfaSecuritySettings({ canRecover, onClose }: { canRecover: boolean; onClose: () => void }) {
    const [securityBusy, setSecurityBusy] = useState(false);
    const [recovering, setRecovering] = useState(false);
    const [emailBusy, setEmailBusy] = useState(false);
    const close = useRef<HTMLButtonElement>(null);
    const panel = useMfaDialog(onClose, securityBusy || recovering || emailBusy);
    useEffect(() => { close.current?.focus(); }, []);

    return <div className={styles.overlay}><section ref={panel} className={`${styles.panel} max-h-[90vh] overflow-y-auto`} role="dialog" aria-modal="true" aria-labelledby="mfa-settings-title">
        <div className="flex items-center justify-between gap-4"><h1 id="mfa-settings-title" className="text-2xl font-bold">Account security</h1><button ref={close} className={styles.secondary} disabled={securityBusy || recovering || emailBusy} onClick={onClose}>Close</button></div>
        <MfaSecuritySection disabled={recovering || emailBusy} onBusyChange={setSecurityBusy} />
        <EmailChangeSection disabled={securityBusy || recovering} onBusyChange={setEmailBusy} />
        {canRecover && <section className="space-y-4 border-t border-slate-200 pt-5"><h2 className="text-lg font-bold">Super admin recovery</h2>
            <MfaRecoveryForm disabled={securityBusy || emailBusy} onBusyChange={setRecovering} />
        </section>}
    </section></div>;
}
